module.exports = __webpack_public_path__ + "static/img/pkflfx.825e88d3.png";